var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"intro"},[_c('div',{staticClass:"logo-row"},[_c('img',{staticClass:"logo-row__energy-saver",attrs:{"src":require("../../../assets/logo-occ.svg"),"alt":"Energy Saver"}}),_c('img',{staticClass:"logo-row__metis",attrs:{"src":require("../../../assets/logo-metis.png"),"alt":"Metis"}})])])
}]

export { render, staticRenderFns }